import { axios } from '@Root/API'

export const get = (engagementId, qualificationAwardId) => {
	return axios.get(`student-engagement/${engagementId}/qualification-awarded/${qualificationAwardId}`)
}
